module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-Light.c553a87a.eot";